<template>
  <div class="customer-select">
    <div v-if="disabled" class="disabled-box"></div>
    <el-dropdown
      ref="dropdownRef"
      placement="bottom"
      popper-class="customer-select__popper"
      trigger="click"
      @visible-change="focusSearchInput"
    >
      <div
        class="customer-select__dropdown"
        :class="{ 'is-show-clear': isShowClear && modelValue.id !== '0' }"
        style="width: 248px"
      >
        <div v-if="modelValue?.id" class="customer-select__name text-overflow">
          {{ modelValue.name }}
        </div>
        <div v-else class="customer-select__placeholder">请选择客户</div>
        <i class="icon-arrow-down-s-line t-iconfont" />
        <i v-if="isShowClear" class="icon-close-circle-line t-iconfont" @click.stop="handleClear" />
      </div>
      <template #dropdown>
        <el-dropdown-menu v-loading="loading" style="width: 248px; padding: 0">
          <div :class="{ 'is-style-top': styleFix }" style="padding: 5px 16px">
            <el-input
              ref="inputRef"
              v-model="searchValue"
              placeholder="请输入客户名称"
              :prefix-icon="Search"
              @input="getList"
            />
          </div>
          <div class="drop-menu-desc" style="margin: 5px 16px">按最近编辑从近到早排序</div>

          <el-dropdown-item
            v-for="item in customerList"
            :key="item.id"
            @click="handleSelectCustomer(item)"
          >
            <span class="text-overflow">{{ item.name }}</span>
          </el-dropdown-item>
          <div
            v-if="addCustomerShow"
            class="customer-select__add-cutsomer"
            :class="{ 'is-style-bottom': styleFix }"
          >
            <i class="icon-user-line t-iconfont"></i>
            <span>未找到客户？</span>
            <span class="new" @click="handlAddcustomer">新建客户</span>
          </div>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script setup>
import { ref, onMounted, useTemplateRef } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { getCustomerList } from '@/api'

const inputRef = useTemplateRef('inputRef')
const focusSearchInput = (flag) => {
  // 打开下拉菜单时，flag为true，此时需要聚焦输入框
  if (flag) {
    setTimeout(() => {
      inputRef.value?.focus?.({ preventScroll: true })
    }, 500)
  }
}

const modelValue = defineModel('modelValue', { type: Object, required: true })
const searchValue = ref('')

const dropdownRef = ref(null)

const customerList = ref([])
const loading = ref(true)

const emits = defineEmits(['addCustomer', 'change'])

defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  isShowClear: {
    type: Boolean,
    default: false
  },
  addCustomerShow: {
    type: Boolean,
    default: true
  },
  styleFix: {
    type: Boolean,
    default: true
  }
})

const handleSelectCustomer = (item) => {
  modelValue.value = item
  emits('change', item)
}

const getList = async () => {
  loading.value = true
  customerList.value = []
  const filter = {
    page: 1,
    pageSize: 10
  }
  if (searchValue.value) {
    filter.nameLike = searchValue.value
  }
  try {
    const res = await getCustomerList(filter)
    customerList.value = res.result.customerList
  } catch (error) {
    console.log(error)
  }
  loading.value = false
}

function handleClear() {
  modelValue.value = {
    name: '全部客户',
    id: '0'
  }
}

const handlAddcustomer = () => {
  emits('addCustomer')
}

onMounted(() => {
  getList()
})

defineExpose({
  getList,
  dropdownRef
})
</script>

<style lang="less">
.customer-select__add-cutsomer {
  padding: 12px 14px 7px 14px;
  font-family: PingFang SC;
  font-size: 14px;
  line-height: 20px;
  color: #969799;
  box-sizing: border-box;
  border-width: 1px 0px 0px 0px;
  border-style: solid;
  border-color: #f2f3f5;
  i {
    margin-right: 4px;
  }
  .new {
    cursor: pointer;
    color: #248df5;
  }
}

.is-style-top {
  position: sticky;
  top: 0;
  background: #fff;
}

.is-style-bottom {
  position: sticky;
  bottom: 0;
  background: #fff;
}

.customer-select__popper {
  .el-dropdown-menu {
    max-height: min(320px, calc(100vh - 24px));
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>

<style scoped lang="less">
.drop-menu-desc {
  font-size: 12px;
  line-height: 16px;
  color: #969799;
}
.customer-select {
  flex: 1;
  position: relative;
  width: 100%;
  .customer-select__name {
    flex: 1;
  }
  .disabled-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(243, 246, 249, 0.6);
    z-index: 10;
    cursor: not-allowed;
  }
}
.customer-select {
  .el-dropdown {
    width: 100%;

    .el-dropdown__list {
      max-height: 300px;
      overflow-y: auto;
    }
  }

  .customer-select__dropdown {
    cursor: pointer;
    flex: 1;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 7px 12px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #e5e6eb;
    width: 100%;
    .customer-select__name {
      margin-right: 8px;
      width: 100%;
    }

    .customer-select__placeholder {
      color: #c8c9cc;
    }
  }
}
.icon-close-circle-line {
  display: none;
}
.is-show-clear:hover {
  .icon-close-circle-line {
    display: block;
  }
  .icon-arrow-down-s-line {
    display: none;
  }
}

.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
